import { RESTSerializer } from '@warp-drive/legacy/serializer/rest';

export default class Base extends RESTSerializer {
  payloadKeyFromModelName(modelName) {
    let model = super
      .payloadKeyFromModelName(modelName)
      .replace(/^milestones\//, '');
    if (model === 'set') {
      return 'templateSet';
    }
    return model + 'Template';
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey(
      'milestones/' + key.replace(/Template/i, ''),
    );
  }
}
